/**
 * Crea los carteles de Mano
 * @param {*} scene
 */
export function crearDisplays(scene) {
  /*/=======================================================================================\*\
  ||                        CREAR DISPLAYS APUESTA MANO 2 JUGADOR 1                          ||
  \*\=======================================================================================/*/
  scene.displayApuestaJugador1Mano2 = scene.add.image(
    660,
    346,
    'displayApuesta'
  );
  scene.displayApuestaJugador1Mano2.setDepth(300);
  scene.displayApuestaJugador1Mano2.setVisible(false);

  /*/=======================================================================================\*\
  ||                     CREAR DISPLAYS APUESTA SEGURO MANO 1 JUGADOR 1                      ||
  \*\=======================================================================================/*/
  scene.displayApuestaJugador1Seguro = scene.add.image(
    340,
    346,
    'displayApuesta'
  );
  scene.displayApuestaJugador1Seguro.setDepth(300);
  scene.displayApuestaJugador1Seguro.setVisible(false);

  /*/=======================================================================================\*\
  ||                      CREAR DISPLAYS VALOR CARTAS MANO 1 JUGADOR 1                       ||
  \*\=======================================================================================/*/
  scene.displayValorCartasJugador1Mano1Valido = scene.add.image(
    394,
    198,
    'displayValorCartasValido'
  );
  scene.displayValorCartasJugador1Mano1Valido.setDepth(300);
  scene.displayValorCartasJugador1Mano1Valido.setVisible(false);

  scene.displayValorCartasJugador1Mano1Exacto21 = scene.add.image(
    394,
    198,
    'displayValorCartasExacto21'
  );
  scene.displayValorCartasJugador1Mano1Exacto21.setDepth(300);
  scene.displayValorCartasJugador1Mano1Exacto21.setVisible(false);

  scene.displayValorCartasJugador1Mano1Excede21 = scene.add.image(
    406,
    198,
    'displayValorCartasExcede21'
  );
  scene.displayValorCartasJugador1Mano1Excede21.setDepth(300);
  scene.displayValorCartasJugador1Mano1Excede21.setVisible(false);

  /*/=======================================================================================\*\
  ||                      CREAR DISPLAYS VALOR CARTAS MANO 2 JUGADOR 1                       ||
  \*\=======================================================================================/*/

  scene.displayValorCartasJugador1Mano2 = scene.add.image(
    554,
    126,
    'displayValorCartas'
  );
  scene.displayValorCartasJugador1Mano2.setDepth(300);
  scene.displayValorCartasJugador1Mano2.setVisible(false);

  scene.displayValorCartasJugador1Mano2Valido = scene.add.image(
    554,
    126,
    'displayValorCartasValido'
  );
  scene.displayValorCartasJugador1Mano2Valido.setDepth(300);
  scene.displayValorCartasJugador1Mano2Valido.setVisible(false);

  scene.displayValorCartasJugador1Mano2Exacto21 = scene.add.image(
    554,
    126,
    'displayValorCartasExacto21'
  );
  scene.displayValorCartasJugador1Mano2Exacto21.setDepth(300);
  scene.displayValorCartasJugador1Mano2Exacto21.setVisible(false);

  scene.displayValorCartasJugador1Mano2Excede21 = scene.add.image(
    554,
    126,
    'displayValorCartasExcede21'
  );
  scene.displayValorCartasJugador1Mano2Excede21.setDepth(300);
  scene.displayValorCartasJugador1Mano2Excede21.setVisible(false);

  /*/=======================================================================================\*\
  ||                      CREAR DISPLAYS VALOR CARTAS MANO 1 DEALER                          ||
  \*\=======================================================================================/*/
  scene.displayValorCartasDealerManoValido = scene.add.image(
    394,
    26,
    'displayValorCartasValido'
  );
  scene.displayValorCartasDealerManoValido.setDepth(300);
  scene.displayValorCartasDealerManoValido.setVisible(false);

  scene.displayValorCartasDealerManoExacto21 = scene.add.image(
    394,
    26,
    'displayValorCartasExacto21'
  );
  scene.displayValorCartasDealerManoExacto21.setDepth(300);
  scene.displayValorCartasDealerManoExacto21.setVisible(false);

  scene.displayValorCartasDealerManoExcede21 = scene.add.image(
    406,
    26,
    'displayValorCartasExcede21'
  );
  scene.displayValorCartasDealerManoExcede21.setDepth(300);
  scene.displayValorCartasDealerManoExcede21.setVisible(false);

  /*/=======================================================================================\*\
  ||                             CREAR DISPLAY DE PREMIO                                     ||
  \*\=======================================================================================/*/
  scene.displayPremio = scene.add.image(898, 444, 'displayPremio');
  scene.displayPremio.setDepth(300);
  scene.displayPremio.setVisible(false);
}
